import { create } from 'zustand';

interface UploadState {
  file: File | null;
  uploadId: string | null;
  storagePath: string | null;
  headers: string[];
  sample: Record<string, string>[];
  mapping: Record<string, string>;
  suggestions: Record<string, string>;
  validationErrors: Record<number, string[]>;
  status: 'idle' | 'uploading' | 'parsing' | 'mapped' | 'validated' | 'creating' | 'complete' | 'error';
  portfolioId: string | null;
  portfolioName: string;
  
  setFile: (file: File | null) => void;
  setUploadId: (id: string | null) => void;
  setStoragePath: (path: string | null) => void;
  setHeaders: (headers: string[]) => void;
  setSample: (sample: Record<string, string>[]) => void;
  setMapping: (mapping: Record<string, string>) => void;
  setSuggestions: (suggestions: Record<string, string>) => void;
  setValidationErrors: (errors: Record<number, string[]>) => void;
  setStatus: (status: UploadState['status']) => void;
  setPortfolioId: (id: string | null) => void;
  setPortfolioName: (name: string) => void;
  reset: () => void;
}

const initialState = {
  file: null,
  uploadId: null,
  storagePath: null,
  headers: [],
  sample: [],
  mapping: {},
  suggestions: {},
  validationErrors: {},
  status: 'idle' as const,
  portfolioId: null,
  portfolioName: '',
};

export const useUploadStore = create<UploadState>((set) => ({
  ...initialState,
  
  setFile: (file) => set({ file }),
  setUploadId: (uploadId) => set({ uploadId }),
  setStoragePath: (storagePath) => set({ storagePath }),
  setHeaders: (headers) => set({ headers }),
  setSample: (sample) => set({ sample }),
  setMapping: (mapping) => set({ mapping }),
  setSuggestions: (suggestions) => set({ suggestions }),
  setValidationErrors: (validationErrors) => set({ validationErrors }),
  setStatus: (status) => set({ status }),
  setPortfolioId: (portfolioId) => set({ portfolioId }),
  setPortfolioName: (portfolioName) => set({ portfolioName }),
  reset: () => set(initialState),
}));
